<template>
<div>
<DialogMonshinnaiyou  ref="monshinDialog" :is_showBtn="false" @submit_monshin="submit_monshin"></DialogMonshinnaiyou>
<DialogSyochinaiyou  ref="syochiDialog" :is_showBtn="false" @submit_syochi="submit_syochi"></DialogSyochinaiyou>

<v-container fluid class="mb-0">
<v-row justify="space-between">
    <v-col cols="8" class="text-left d-flex align-start">
        <v-btn color="" class="mygreen white--text mr-6" to="/reserve">
            <img class="img" src="/img/icon_plus.svg" style="margin-left: -6px;margin-right:6px;width:20px;" />
        来院登録</v-btn>


        <DialogYoyakuSearch :tantoui="dic_doctor" :isSameroute="true" @search="search"></DialogYoyakuSearch>

        <div style="display: inline-block; height:36px;" class="switch_block ml-4">
                <img class="img" src="/img/switch_table.svg" height="100%" />
            <a href="/reservecalendar"></a>
        </div>

    </v-col>


    <v-col cols="4" class="text-left d-flex align-center">
        <v-row justify="center">
            <v-spacer></v-spacer>
            <v-col cols="5" class="pr-0">
                <v-menu
                v-model="menu1"
                :close-on-content-click="false"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
                min-width="auto" >
                <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                    v-model="date1"
                    append-icon="mdi-calendar-month"
                    outlined
                    v-bind="attrs"
                    v-on="on"
                    @blur="date_change"></v-text-field>
                </template>
                <v-date-picker
                    v-model="date1"
                    @input="menu1 = false"
                    color="green lighten-1"
                    :no-title="true"
                    locale="jp-ja"
                    :day-format="date => new Date(date).getDate()"
                    @change="date_change"
                ></v-date-picker>
                </v-menu>
            </v-col>
            <v-col cols="1" class="pa-0"><div style="padding: 20px 10px;">～</div></v-col>
            <v-col cols="5" class="pl-0">
                <v-menu
                v-model="menu2"
                :close-on-content-click="false"
                :nudge-left="80"
                transition="scale-transition"
                offset-y
                min-width="auto"
                >
                <template v-slot:activator="{ on, attrs }">
                <v-text-field
                v-model="date2"
                append-icon="mdi-calendar-month"
                outlined
                v-bind="attrs"
                v-on="on"
                @blur="date_change"
                ></v-text-field>
                </template>
                <v-date-picker
                    v-model="date2"
                    @input="menu2 = false"
                    color="green lighten-1"
                    :no-title="true"
                    locale="jp-ja"
                    :day-format="date => new Date(date).getDate()"
                    @change="date_change"
                ></v-date-picker>
                </v-menu>
            </v-col>
        </v-row>
    </v-col>
</v-row>
</v-container>



<v-data-table
fixed-header
:headers="headers"
:items="records"
:items-per-page="20"
sort-by="calories"
class="elevation-1"
:height="tableHeight"
v-resize="onResize"
@click:row="rowClick"
>
<template v-slot:item.name="{ item }">
    <div v-html="item.name"></div>
</template>
<template v-slot:item.unit="{ item }">
    <div>UNIT {{item.unit}}</div>
</template>

<!-- メモ列: 100文字まで（改行除去）/ 超過時はホバーで全文（改行反映） -->
<template v-slot:item.memo="{ item }">
  <div>
    <v-tooltip bottom v-if="item.memo && item.memo.replace(/\r?\n/g, '').length > 100">
      <template v-slot:activator="{ on, attrs }">
        <span v-bind="attrs" v-on="on">{{ shortMemo(item.memo) }}</span>
      </template>
      <div class="memo-tooltip-content">{{ item.memo }}</div>
    </v-tooltip>
    <span v-else>{{ shortMemo(item.memo) }}</span>
  </div>
  
</template>


<template v-slot:no-data>
<div>
データがありません。
</div>
</template>
</v-data-table>
</div>
</template>

<script>
// @ is an alias to /src
/* eslint-disable */
import mycolor from '@/mycolor.js';
import axios from 'axios';
import {mapGetters} from 'vuex';
import DialogMonshinnaiyou from '@/components/DialogMonshinnaiyou.vue';
import DialogSyochinaiyou from '@/components/DialogSyochinaiyou.vue';
import DialogYoyakuSearch from '@/components/DialogYoyakuSearch.vue';
import io from 'socket.io-client';
/* eslint-disable */

  export default {
    components:{
        DialogMonshinnaiyou,
        DialogSyochinaiyou,
        DialogYoyakuSearch
    },


    // datas
    data(){
        return {

          dic_doctor: [{'id': 1, 'doctor':'医師一太'}],

          reserve_id: '',
          date1: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
          date2: (new Date(Date.now() + (24*60*6*7*10000) - (new Date()).getTimezoneOffset() * 60000) ).toISOString().substr(0, 10),
          menu1: false,
          menu2: false,
          modal: false,


          title: '予約一覧',
          tableHeight: 700,
          dialog: false,
          dialogDelete: false,
          headers: [
            {
              text: '来院日時',
              align: 'start',
              value: 'date_come',
            },
            { text: '予約番号', value: 'id' },
            { text: '診察券番号', value: 'bangou' },
            { text: '患者名', value: 'name' },
            { text: '担当医', value: 'doctor' },
            { text: 'ユニット', value: 'unit' },
            { text: 'メモ', value: 'memo', sortable: false },
          ],
          records: [],
          editedIndex: -1,
          editedItem: {
            name: '',
            calories: 0,
            fat: 0,
            carbs: 0,
            protein: 0,
          },
          defaultItem: {
            name: '',
            calories: 0,
            fat: 0,
            carbs: 0,
            protein: 0,
          },
        }
    },


    computed: {
      ...mapGetters(['user', 'user_name', 'is_admin']),

      formTitle () {
        return this.editedIndex === -1 ? 'New Item' : 'Edit Item'
      },


    },

    watch: {
      dialog (val) {
        val || this.close()
      },
      dialogDelete (val) {
        val || this.closeDelete()
      },
    },

    created () {
        console.log('%ccreated: ReserveListView.vue', mycolor.purple);
      this.get_tantoui();

      this.initialize()
      this.onResize();
    },

  methods: {
        shortMemo(memo){
            try{
                if(!memo){ return ''; }
                // 改行除去 → 最大100文字 → 100超は省略記号
                const flat = (memo+'').replace(/\r?\n/g, '');
                return flat.length > 100 ? (flat.substring(0, 100) + '…') : flat;
            }catch(e){
                return '';
            }
        },
        date_change(){
            console.log('date_change()');

            let data = {
                id: "",
                bangou: "",
                mei: "",
                mei_kana: "",
                sei: "",
                sei_kana: "",
                from: this.date1,
                to: this.date2,
                staff_id: "",
                unit: "",
            };

            console.log('data', data);
            this.search(data)
        },
        search(data){
            console.log('search()');
            console.log( data );

            var api = '/reserve_list_search';
            axios.post(api,  data )
              .then((res) => {
                console.log(`%c${api}`, mycolor.orange);
                console.log(res);
                this.records = res.data;
              })
              .catch((error) => {
                // eslint-disable-next-line
                console.error(error);
              });
        },

        get_tantoui(){
            // 担当医の辞書を取得
            axios.get('/get_doctors')
            .then((res) => {
                console.group();
                console.log('%c /get_doctors', mycolor.api);
                console.log('担当医のリスト取得');
                console.log('res: ', res.data);
                console.groupEnd();
                this.dic_doctor = res.data;
            })
            .catch((error) => {
              // eslint-disable-next-line
              console.error(error);
            });
        },
        showMonshin(reserve_id){
            console.log('components: showMonshin()');
            this.$refs.monshinDialog.showDialog(reserve_id);
        },
        showSyochi(reserve_id){
            console.log('components: showSyochi()');
            this.$refs.syochiDialog.showDialog(reserve_id);
        },
        submit_monshin(data){
                console.log('submit_monshin');
                console.log(data);


                const path = '/reserve_update_monshin/' + this.reserve_id;
                axios.post(path, data)
                  .then((res) => {
                    console.log(res.data);

                    if( res.data.status==="OK" ){
                        // Find the index of the updated item
                        const index = this.records.findIndex(item => item.id === this.reserve_id);
                        if (index !== -1) {
                          // Update the item in the records array to trigger reactivity
                          this.records[index].youbou = data.youbou;
                        }
                    }

                  })
                  .catch((error) => {
                    // eslint-disable-next-line
                    console.error(error);
                  });

                return false;
        },
        submit_syochi(data){
                console.log('submit_syochi');
                console.log(data.data);

                const path = '/reserve_update_syochi/' + this.reserve_id;
                axios.post(path, data)
                  .then((res) => {
                    console.log(res);

                    if( /lastid=/.test(res.data) ){
                        this.snackbar_text = `問診内容を保存しました`
                        this.snackbar = true
                    }

                  })
                  .catch((error) => {
                    // eslint-disable-next-line
                    console.error(error);
                  });

                return false;
        },
        rowClick(v){
            console.log('rowClick');
            console.log(v);
            const path = '/reserve/'+v.id;
            this.$router.push(path).catch(()=>{});
        },

      btnColor (status) {
        console.log('btnColor');
        return status ? 'blue-grey darken-2' : '';
      },
      memoText (status) {
        return status ? 'あり' : 'なし'
      },

      onResize() {
        console.log('onResize');
        console.log(this);
        this.tableHeight = window.innerHeight - 240;
      },


      // 初期化 todo:
      initialize () {

        console.log('initialize');
        console.log( '$route',  this.$route );


        if( this.$route.params.data ){
            console.log('検索条件あり');
            console.log( this.$route.params.data );

            let path = '/reserve_list_search';

            axios.post(path,  this.$route.params.data )
              .then((res) => {
                console.log(res);
                this.records = res.data;
              })
              .catch((error) => {
                // eslint-disable-next-line
                console.error(error);
              });

        }else{
            console.log('検索条件なし');

            let path = '/reserve_list';

            axios.get(path)
              .then((res) => {
                console.log(res);
                this.records = res.data;
              })
              .catch((error) => {
                // eslint-disable-next-line
                console.error(error);
              });
        }


      },

      editItem (item) {
        console.log('editedItem()');
        console.log(this.records);
        console.log(item);
        this.reserve_id = item.id;
        this.showMonshin(item.id);
        return false;
        /*
        this.editedIndex = this.records.indexOf(item)
        this.editedItem = Object.assign({}, item)
        this.dialog = true
        */
      },

      editItem2 (item) {
        console.log('editItem2()');
        console.log(this.records);
        console.log(item);
        this.reserve_id = item.id;
        this.showSyochi(item.id);
        return false;
        /*
        this.editedIndex = this.records.indexOf(item)
        this.editedItem = Object.assign({}, item)
        this.dialog = true
        */
      },



      deleteItem (item) {
        console.log(item);
        this.editedIndex = this.records.indexOf(item)
        this.editedItem = Object.assign({}, item)
        this.dialogDelete = true
      },

      deleteItemConfirm () {
        this.records.splice(this.editedIndex, 1)
        this.closeDelete()
      },

      close () {
        this.dialog = false
        this.$nextTick(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        })
      },

      closeDelete () {
        this.dialogDelete = false
        this.$nextTick(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        })
      },

      save () {
        if (this.editedIndex > -1) {
          Object.assign(this.records[this.editedIndex], this.editedItem)
        } else {
          this.records.push(this.editedItem)
        }
        this.close()
      },
    },

  }
</script>

<style scoped>
.switch_block{
    display: inline-block;
    position: relative;
}
.switch_block a{
    cursor: pointer;
    position: absolute;
    top:0;
    left:0;
/*    background: blue; */
    width: 50%;
    height: 100%;
}
.v-date-picker-table.v-date-picker-table--date > table > tbody tr td:nth-child(1) .v-btn__content {
    color:red
}
.v-date-picker-table.v-date-picker-table--date > table > tbody tr td:nth-child(7) .v-btn__content {
    color:blue
}
/*
.v-date-picker-table th{
	color:red;
}
*/
/deep/ .v-input__append-inner{
    margin: 0 !important;
    margin: auto !important;
}
/deep/ fieldset{
    background: #fff;
}
/deep/ .kana{
    font-size: 9px;
}
/deep/ .v-toolbar__content{
    background: red !important;
}

.memo-tooltip-content{
    max-width: 480px;
    white-space: pre-wrap; /* 改行維持 */
}
</style>
